import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { farmerBenefits } from "@/mocks/siteData";

export default function ForFarmersSection() {
  return (
    <section id="partner" className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                For Farmers
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
              Turn Your Farm Into an Experience
            </h2>
            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              Your farm has more to offer than just crops. Your knowledge, traditions, stories,
              food, farming practices, and way of life can create meaningful experiences for
              visitors.
            </p>
            <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
              Rythugaru helps farmers showcase their farms and offer curated experiences to
              families, students, corporates, and travelers.
            </p>

            <div className="mt-8 rounded-lg overflow-hidden w-full h-56 md:h-72">
              <img
                src="https://readdy.ai/api/search-image?query=Fresh%20documentary%20portrait%20of%20a%20smiling%20elderly%20Indian%20farmer%20standing%20in%20a%20lush%20green%20field%20holding%20a%20basket%20of%20fresh%20vegetables%2C%20soft%20natural%20light%2C%20coconut%20trees%20behind%2C%20painterly%20stylized%20earthy%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1000&height=750&seq=rythugaru-farmer-portrait&orientation=landscape"
                width={1000}
                height={750}
                alt="Smiling Indian farmer holding a basket of fresh vegetables in the field"
                title="Become a Rythugaru farm partner"
                className="w-full h-full object-cover object-top"
                decoding="async"
              />
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={120}>
            <div className="bg-primary-900 rounded-lg p-7 md:p-10">
              <h3 className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
                Rythugaru helps you with:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mt-7">
                {farmerBenefits.map((benefit) => (
                  <div
                    key={benefit.label}
                    className="flex items-center gap-3 bg-primary-800/70 border border-primary-700 rounded-md px-4 py-3.5"
                  >
                    <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
                      <i className={`${benefit.icon} text-lg`}></i>
                    </span>
                    <span className="text-sm font-medium text-background-100">{benefit.label}</span>
                  </div>
                ))}
              </div>

              <div className="mt-9 pt-7 border-t border-primary-700">
                <p className="text-background-200 text-base">You focus on your farm.</p>
                <p className="font-heading text-2xl md:text-3xl text-accent-300 mt-2">
                  We help bring the right visitors to you.
                </p>
                <Link
                  to="/farm-partner"
                  className="mt-7 inline-flex items-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Become a Rythugaru Farm Partner
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}